import { FC } from 'react'

import { ISvgClass } from '../interface'

const CalendarMonthOutlineIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 18 20"
      fill="none"
      {...props}
    >
      <path
        d="M4 10H6V12H4V10ZM18 4V18C18 19.11 17.11 20 16 20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V4C0 2.9 0.9 2 2 2H3V0H5V2H13V0H15V2H16C16.5304 2 17.0391 2.21071 17.4142 2.58579C17.7893 2.96086 18 3.46957 18 4ZM2 6H16V4H2V6ZM16 18V8H2V18H16ZM12 12V10H14V12H12ZM8 12V10H10V12H8ZM4 14H6V16H4V14ZM12 16V14H14V16H12ZM8 16V14H10V16H8Z"
        fill="inherit"
      />
    </svg>
  )
}

export default CalendarMonthOutlineIcon
